import React, { Fragment } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import moment from 'moment';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { ReactComponent as CartIcon } from '@src/assets/icons/event-step-cart.svg';
import { ReactComponent as TicketIcon } from '@src/assets/icons/event-step-ticket.svg';
import { ReactComponent as RankingIcon } from '@src/assets/icons/event-step-ranking.svg';
import Typography from '@src/new-components/Typography';
import { StyledRules } from './index.style';

const DATE_FORMAT = 'DD/MM/YYYY';
const BOLD = { b: <b /> };

const RuleSection = ({ config, thresholdText }) => {
  const { t } = useTranslation();
  const { startTime, endTime, drawTime, livestreamUrl } = config;

  // `Trans` fills the link text from the translation.
  /* eslint-disable jsx-a11y/anchor-has-content */
  const livestreamLink = (
    <a href={livestreamUrl} target="_blank" rel="noreferrer" />
  );
  /* eslint-enable jsx-a11y/anchor-has-content */

  const steps = [
    {
      icon: <CartIcon />,
      title: 'topPaidEventStepBuyTitle',
      description: 'topPaidEventStepBuyDescription',
    },
    {
      icon: <TicketIcon />,
      title: 'topPaidEventStepCodeTitle',
      description: 'topPaidEventStepCodeDescription',
      values: { threshold: thresholdText },
    },
    {
      icon: <RankingIcon />,
      title: 'topPaidEventStepDrawTitle',
      description: 'topPaidEventStepDrawDescription',
      values: { date: moment(drawTime).format(DATE_FORMAT) },
    },
  ];

  return (
    <StyledRules>
      <div className="rules-heading">
        <Typography
          variant="body-24-semibold"
          component="h2"
          className="section-title"
        >
          {t('topPaidEventRulesTitle')}
        </Typography>
        <Typography variant="body-14-regular" className="period">
          {t('topPaidEventPeriod', {
            start: moment(startTime).format(DATE_FORMAT),
            end: moment(endTime).format(DATE_FORMAT),
          })}
        </Typography>
      </div>
      <div className="rules-card">
        <Typography variant="body-16-regular" className="how-to-join">
          {t('topPaidEventHowToJoin')}
        </Typography>
        <div className="steps">
          {steps.map((step, index) => (
            <Fragment key={step.title}>
              {index > 0 && <ChevronRightRoundedIcon className="step-arrow" />}
              <div className="step">
                <div className="icon-box">{step.icon}</div>
                <div className="step-body">
                  <Typography variant="body-16-semibold" className="step-title">
                    {t(step.title)}
                  </Typography>
                  <Typography variant="body-14-regular" className="slate-text">
                    <Trans
                      t={t}
                      i18nKey={step.description}
                      values={step.values}
                      components={BOLD}
                    />
                  </Typography>
                </div>
              </div>
            </Fragment>
          ))}
        </div>
        <div className="rules-divider" />
        <Typography
          variant="body-16-regular"
          component="ul"
          className="rule-details"
        >
          <li>
            <Trans t={t} i18nKey="topPaidEventAudience" components={BOLD} />
          </li>
          <li>
            {livestreamUrl ? (
              <Trans
                t={t}
                i18nKey="topPaidEventFormatWithLink"
                components={{ ...BOLD, a: livestreamLink }}
              />
            ) : (
              <Trans t={t} i18nKey="topPaidEventFormat" components={BOLD} />
            )}
          </li>
        </Typography>
      </div>
    </StyledRules>
  );
};

export default RuleSection;
